import { render, staticRenderFns } from "./DigitalBrokerSourceSection.vue?vue&type=template&id=07f57fa3"
import script from "./DigitalBrokerSourceSection.vue?vue&type=script&lang=js"
export * from "./DigitalBrokerSourceSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports